// Pulled from Shopify's Dawn (https://github.com/Shopify/dawn/blob/64952383e78eae6f73ccb2abcd3a7614f2f5b5a2/assets/global.js#L692)
// Some functionality has been removed for simplicity

class DeferredMedia extends HTMLElement {
  constructor() {
    super()

    this.createObserver()
    this.querySelector('.js-play')?.addEventListener('click', () => {
      this.togglePlayPause()
    })
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        // If the element is visible
        if (entry.isIntersecting) {
          this.loadContent()
        }
      })
    })

    observer.observe(this)
  }

  updatePlayButtonLabel() {
    const playButton = this.querySelector('.js-play')
    if (!playButton) return

    const videoLabel = this.getAttribute('data-video-label') || ''
    const action = playButton.classList.contains('is-playing')
      ? window.langMessages?.['accessibility.pause_video'] || 'Pause video'
      : window.langMessages?.['accessibility.play_video'] || 'Play video'

    playButton.setAttribute(
      'aria-label',
      videoLabel ? `${videoLabel}, ${action}` : action
    )
  }

  loadContent() {
    if (this.getAttribute('loaded')) return

    const content = document.createElement('div')
    content.appendChild(
      this.querySelector('template').content.firstElementChild.cloneNode(true)
    )

    this.setAttribute('loaded', true)
    const deferredElement = this.appendChild(
      content.querySelector('video, model-viewer, iframe')
    )

    if (deferredElement.nodeName === 'VIDEO') {
      // The video is decorative; the play/pause button is the accessible control.
      deferredElement.setAttribute('aria-hidden', 'true')
      deferredElement.setAttribute('tabindex', '-1')
      deferredElement.removeAttribute('aria-label')
      this.updatePlayButtonLabel()

      if (deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play()
      }
    }
  }

  pauseAllVideos() {
    document.querySelectorAll('deferred-media video').forEach((video) => {
      video.pause()
      const deferredMedia = video.closest('deferred-media')
      deferredMedia?.querySelector('.js-play')?.classList.remove('is-playing')
      deferredMedia?.updatePlayButtonLabel()
    })
  }

  playAllVideos() {
    document.querySelectorAll('video').forEach((video) => {
      video.play()
      const deferredMedia = video.closest('deferred-media')
      deferredMedia?.querySelector('.js-play')?.classList.add('is-playing')
      deferredMedia?.updatePlayButtonLabel()
    })
  }

  togglePlayPause() {
    const video = this.querySelector('video')
    if (video.paused) {
      this.playAllVideos()
    } else {
      this.pauseAllVideos()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)
